import React from 'react';
import { Link } from "react-router-dom";
import PrimaryHeading from "../../components/PrimaryHeading/PrimaryHeading";
import HeadingGradient from "../../components/HeadingGradient/HeadingGradient";
import Tile from "../../components/Tile/Tile";
import SecondaryHeading from "../../components/SecondaryHeading/SecondaryHeading";
import TileLegend from "../../components/TileLegend/TileLegend";
import ThirdHeading from "../../components/ThirdHeading/ThirdHeading";
import BarChartVertical from "../../components/BarChartVertical/BarChartVertical";
import MegaDrivers from "../../components/MegaDrivers/MegaDrivers";
import ChartTable from "../../components/ChartTable/ChartTable";
import CardsTiles from "../../components/CardsTiles/CardsTiles";

function SectionWhy(
    {
        triggersData,
        megaDriversData,
        manageLinkAccordingToPermissions,
        highlyIndexedNeeds,
        topSpecificNeeds,
        forwardRef,
        microDriversData,
        activeMicroDriverCategoryName,
        setActiveMicroDriverCategoryName,
        microDriversActiveCategory,
        name,
    }) {

    return (
        <>
            <div className="details-chart">
                <PrimaryHeading>
                    <HeadingGradient>Why</HeadingGradient>
                    <span>triggers & needs</span>
                </PrimaryHeading>
                <Tile>
                    <div className="chart">
                        <SecondaryHeading>
                            triggers
                            {/*<TileLegend/>*/}
                        </SecondaryHeading>
                        <ThirdHeading>
                            % of events that are initially activated by...
                        </ThirdHeading>
                        <div className="row">
                            <div className="col-50">
                                <BarChartVertical
                                    data={triggersData.slice(0, (triggersData.length + 1) / 2)}
                                    wholeData={triggersData}
                                />
                            </div>
                            <div className="col-50">
                                <BarChartVertical
                                    data={triggersData.slice((triggersData.length + 1) / 2)}
                                    wholeData={triggersData}
                                />
                            </div>
                        </div>
                    </div>
                </Tile>
            </div>
            <div className="details-chart">
                <Tile>
                    <div className="chart">
                        <SecondaryHeading isCentered>
                            Mega needs
                        </SecondaryHeading>
                        <MegaDrivers data={megaDriversData.map(manageLinkAccordingToPermissions)}/>
                    </div>
                </Tile>
            </div>
            <div className="details-chart">
                <Tile>
                    <div className="chart">
                        <div className="row">
                            <div className="col-33">
                                <ChartTable
                                    title="Highly indexed Needs"
                                    subtitle="motivations that are particularly important for this event"
                                    eventName={name}
                                    data={highlyIndexedNeeds.map(manageLinkAccordingToPermissions)}
                                    hasTooltips
                                />
                            </div>
                            <div className="col-67">
                                <ChartTable
                                    title="Top Specific Needs"
                                    subtitle="most common needs associated with this event"
                                    data={topSpecificNeeds.map(manageLinkAccordingToPermissions)}
                                    columnsCount={2}
                                />
                            </div>
                        </div>
                    </div>
                </Tile>
            </div>
            <div
                className="details-chart"
                ref={forwardRef}
            >
                <Tile>
                    <div className="chart">
                        <SecondaryHeading isCentered>
                            Micro Drivers
                        </SecondaryHeading>
                        <CardsTiles
                            items={microDriversData}
                            activeItemName={activeMicroDriverCategoryName}
                            handleItemClick={setActiveMicroDriverCategoryName}
                            handleOverlayClick={() => setActiveMicroDriverCategoryName('')}
                        />
                        {activeMicroDriverCategoryName && (
                            <div
                                className="needs-dropdown"
                            >
                                {microDriversActiveCategory.items
                                    .sort(({value: a}, {value: b}) => a < b ? 1 : -1)
                                    .map(manageLinkAccordingToPermissions)
                                    .map((item, inx) => (
                                        <div
                                            key={inx}

                                            className="needs-dropdown__item"
                                        >
                                            {item.link ? (
                                                <Link
                                                    to={item.link}
                                                    className="needs-dropdown__title"
                                                >
                                                    {item.name}
                                                </Link>
                                            ) : (
                                                <div className="needs-dropdown__title">
                                                    {item.name}
                                                </div>
                                            )}
                                            <div
                                                className="needs-dropdown__value">{item.value}%
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        )}
                    </div>
                </Tile>
            </div>
        </>
    );
}

export default SectionWhy;